import React, { useEffect, FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import Icon from '@common/assets';
import EtcExperienceDesc from '@components/profile/profileOverlay/overlays/experience/experienceWrite/etcExperienceForm/EtcExperienceDesc';
import styles from '../../experience.module.scss';
import { EtcExperiencesVO } from '@domain/vo/profile/ProfileExperienceVO';

import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const Tooltip = () => {
  return (
    <div className={cx('tooltip')}>
      <div className={cx('tooltipBox')}>
        <div className={cx('tooltipInfoWrap')}>
          <div className={cx('tooltipTitle')}>기타 경험이란?</div>
          <p className={cx('tooltipDesc')}>특정한 서식 없이 내 경험을 자유롭게 이야기하는 곳이에요.</p>
        </div>
        <div className={cx('tooltipInfoWrap')}>
          <div className={cx('tooltipTitle')}>경험 작성의 꿀팁 3가지!</div>
          <p className={cx('tooltipDesc')}>1. 같은 형식으로 통일감있게 작성해주세요.</p>
          <p className={cx('tooltipDesc')}>2. 쉽게 이해할 수 있는 표현을 사용해주세요.</p>
          <p className={cx('tooltipDesc')}>3. 숫자를 활용해서 구체적으로 설명해주세요.</p>
        </div>
      </div>
    </div>
  );
};

const TooltipButton = () => {
  return (
    <div className={cx('btnInfoArea')}>
      <a className={cx('btnInfo')} role="button">
        <Icon name="informationLight" width={20} height={20} />
        <Tooltip />
      </a>
    </div>
  );
};

interface IEtcExperienceItemProps {
  index: number;
  prefixName: string;
  onDeleteItem: () => void;
}

const EtcExperienceItem: FC<IEtcExperienceItemProps> = ({ index, prefixName, onDeleteItem }) => {
  const { watch } = useFormContext();
  const isDisabledDeleteBtn = index === 0 && Object.values(watch(prefixName) ?? {}).filter((v) => !!v).length === 0;

  return (
    <div className={cx('activityInner')}>
      <button className={cx('btnDelete')} type="button" disabled={isDisabledDeleteBtn} onClick={onDeleteItem}>
        <Icon name="deleteLight" width={20} height={20} />
        삭제
      </button>

      <EtcExperienceDesc prefixName={prefixName} />
    </div>
  );
};

interface IEtcExperienceFormProps {
  visible: boolean;
}
const EtcExperienceForm = ({ visible }: IEtcExperienceFormProps) => {
  const { control } = useFormContext();

  const fieldName = 'experiences';
  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldName,
  });

  const onAppendEtcExperience = () => {
    append(
      new EtcExperiencesVO({
        description: '',
      }),
    );
  };

  const etcExperiencesEls = fields.map(({ id, ...field }, idx) => {
    const prefixName = `${fieldName}[${idx}]`;
    const onDeleteItem = () => {
      remove(idx);
    };

    return <EtcExperienceItem key={id} index={idx} prefixName={prefixName} onDeleteItem={onDeleteItem} />;
  });

  useEffect(() => {
    if (fields.length === 0) {
      onAppendEtcExperience();
    }
  }, [fields.length]);

  return (
    <div className={cx('activityArea', { hidden: !visible })}>
      <em className={cx('sectionTitle')}>
        기타 경험
        {visible && <TooltipButton />}
      </em>
      {etcExperiencesEls}

      <a className={cx('btnAdd')} role="button" onClick={onAppendEtcExperience}>
        <Icon name="addLight" width={24} height={24} />
        추가
      </a>
    </div>
  );
};

export default EtcExperienceForm;
